import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';

import Login from './components/Login';
import NavigatorWithRoutes from './components/Navigator';

import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import StartPage from "./components/IdVerification/StartPage";
import LoadingPage from "./components/IdVerification/LoadingPage";
import ResultPage from "./components/IdVerification/ResultPage";
import TfcDashOnboardingPage from "./components/TfcDashOnboardingPage";
import IntakeDraftTestPage from "./components/IntakeDraftTestPage";

import './index.css';

const App = () => {
  return (
    <Router>
      <DndProvider backend={HTML5Backend}>
        <div className="app-container bg-gray-100 min-h-screen p-8">
          <Routes>
            {/* Login FIRST - must be before all other routes */}
            <Route path="/login/*" element={<Login />} />
            <Route path="/login" element={<Login />} />

            {/* Everything else goes through NavigatorWithRoutes */}
            <Route path="/*" element={<NavigatorWithRoutes />} />

            <Route path="/id-verification" element={<StartPage />} />
<Route path="/verification/loading" element={<LoadingPage />} />
<Route path="/id-verification/success" element={<ResultPage type="success" />} />
<Route path="/id-verification/failure" element={<ResultPage type="failure" />} />

            {/* Standalone onboarding intake — no realm-prefixed links, no
                Navigator sidebar, but still requires Keycloak login (the
                page itself gates on auth internally — see AuthGate in
                TfcDashOnboardingPage.jsx). Unlike the ID-verification routes
                above, this one is not unauthenticated. */}
            <Route path="/onboarding-intake" element={<TfcDashOnboardingPage />} />

            {/* Dev-only: standalone test page for the onboarding_intake
                prefill/check pipeline, separate from the TFC wizard above.
                Keycloak-gated, same as the routes above. */}
            {/* Intake test page: development builds only (not in production builds). */}
            {process.env.NODE_ENV !== "production" && (
              <Route path="/intake-test" element={<IntakeDraftTestPage />} />
            )}
          </Routes>
        </div>
      </DndProvider>
    </Router>
  );
};

export default App;
